// @ts-check
import { css } from 'lit';

export const vstUiLicenseInfoStyles = css`
  :host {
    display: block;
  }

  #license-info {
    background: var(--vst-color-bg-tertiary);
    border: 1px solid var(--vst-color-fg-primary);
    border-radius: var(--vst-radius);
    flex-shrink: 0;
    margin: auto;
    margin-block-end: var(--vst-space-m);
    max-inline-size: var(--vst-content-max-inline-size);
    min-block-size: fit-content;
    padding: var(--vst-space-s);
    text-align: center;
  }

  .license-name {
    margin-block-end: var(--vst-space-s);
  }

  #license-info.expired {
    background: var(--vst-color-danger);
  }

  #license-info.expired * {
    color: var(--vst-color-light-100);
  }
`;
